import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";

export const AdminCoachEdit = () => {
  const { staff } = useStaffAuthContext();

  const { coach_id } = useParams();

  const [weight, setWeight] = useState("");
  const [accountType, setAccountType] = useState("FREE PLAN"); // Default value for account type
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCoachData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_URL.GET_COACH_BY_ID}/${coach_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });
        const data = await response.json();

        if (response.ok) {
          setWeight(data.weight);
          setAccountType(data.account_type || "FREE PLAN"); // Populate account type
        } else {
          setError(data.error || "Failed to load athlete data.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoachData();
  }, [coach_id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL.UPDATE_COACH_DETAILS_BY_ID}${coach_id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({
          weight,
          account_type: accountType, // Include account type in the update payload
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Failed to update coach data.");
      } else {
        setSuccess("Coach details updated successfully!");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-4 bg-gray-100 pt-16">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-semibold">Edit Coach Details</h1>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Go Back
          </button>
        </div>

        {isLoading && (
          <div className="p-3 mb-4 bg-yellow-100 text-yellow-700 rounded">
            Loading data... Please wait.
          </div>
        )}

        {success && (
          <div className="p-3 mb-4 bg-green-100 text-green-700 rounded">{success}</div>
        )}

        {error && (
          <div className="p-3 mb-4 bg-red-100 text-red-700 rounded">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
             <div>
              <label htmlFor="weight" className="block text-sm font-medium">
                Weight (lbs)
              </label>
              <input
                type="text"
                id="weight"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded"
              />
            </div>
         
          </div>

          <div>
            <label htmlFor="accountType" className="block text-sm font-medium">
              Account Type
            </label>
            <select
              id="accountType"
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded"
              disabled={true}
            >
              <option value="FREE PLAN">FREE PLAN</option>
              <option value="STATIC PLAN">STATIC PLAN</option>
              <option value="AMAX COACHED">AMAX COACHED</option>
            </select>
          </div>

          <button
            type="submit"
            className="w-full mt-4 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={isLoading}
          >
            Update Coach Details
          </button>
        </form>
      </div>
    </div>
  );
};
